import React from "react";
import { Megaphone } from "lucide-react";

export default function Announcements({ items }) {
    if (!items || items.length === 0) return null;
    return (
        <section
            className="relative bg-white brut-border brut-shadow mb-8 sm:mb-10"
            data-testid="announcements-section"
        >
            <div className="flex items-center gap-2 bg-black text-white px-4 py-2">
                <Megaphone size={18} strokeWidth={3} />
                <h2 className="font-display text-sm sm:text-base">
                    Announcements
                </h2>
            </div>
            <ul className="divide-y-[3px] divide-black">
                {items.slice(0, 4).map((a) => (
                    <li
                        key={a.id}
                        className="p-4"
                        data-testid={`announcement-${a.id}`}
                    >
                        <div className="flex flex-wrap items-baseline justify-between gap-2">
                            <h3 className="font-display text-base sm:text-lg leading-tight">
                                {a.title}
                            </h3>
                            <span className="text-[10px] uppercase tracking-widest opacity-70">
                                {new Date(a.created_at).toLocaleDateString()} •{" "}
                                {a.author_email}
                            </span>
                        </div>
                        <p className="mt-2 text-sm whitespace-pre-wrap">
                            {a.body}
                        </p>
                    </li>
                ))}
            </ul>
        </section>
    );
}
